const czh = {
    music: '網易雲音樂',
    findMusic: '發現音樂',
    myMusic: '我的音樂',
    friend: '朋友',
    musician: '音樂人',
    download: '下載',
    autoGenerate: '自動生成',
    date: '日期',
    lang: '語言',
    text: '文本',
    theme: '主題',
    chooseDate: '請選擇日期',
    headerNewWindow: '新窗口',
    baseRole: '普通角色',
    functionalHR: '職能HR',
    systemName: '績效管理系統',
    userManage: '用戶管理',
    roleType: '角色類型',
    roleOrder: '角色排序',
    roleManage: '角色管理',
    roleCode: '角色編碼',
    roleDetail: '角色詳情',
    userName: '用戶名稱',
    roleName: '角色名稱',
    search: '查詢',
    reset: '重置',
    placeholder: '請選擇',
    placeholderSelect: '請選擇',
    userId: '用戶ID',
    employeeNumber: '員工編號',
    chineseName: '中文名',
    AuthorizedRole: '已授權角色',
    operation: '操作',
    roleAuthorization: '角色授權',
    permAuthorization: '数据授權',
    permissionCode: '許可編碼',
    permissionName: '許可名稱',
    permissionDetail: '許可詳情',
    permissionID: '許可ID',
    cancel: '取消',
    confirm: '確定',
    add: '新增',
    edit: '編輯',
    del: '刪除',
    exit: '退出',
    exit2: '退出',
    save: '保存',
    submit: '提交',
    explain: '說明',
    authorizedMenu: '授權菜單',
    description: '描述',
    authorization: '授權',
    dataAuthorization: '數據授權',
    input: '請輸入',
    select: '請選擇',
    resourceManage: '資源管理',
    resourceName: '資源名稱',
    resourceCode: '資源編碼',
    resourceOrder: '資源排序號',
    resourcePath: '資源請求路徑',
    parentID: '父資源ID',
    resourceType: '資源類型',
    createDate: '創建時間',
    updateDate: '更新時間',
    successMsg: '操作成功',
    failMsg: '操作失敗',
    addMsg: '新增成功',
    editMsg: '編輯成功',
    delMsg: '刪除成功',
    addFailMsg: '新增失敗',
    editFailMsg: '編輯保存失敗',
    delFailMsg: '刪除失敗',
    delConfirmMsg: '是否刪除此專案',
    delConfirmTips: '是否刪除此人員？',
    delConfirmTips2: '確定刪除嗎？',
    index: '序號',
    typeId: '類別ID',
    code: '編碼',
    content: '內容',
    appliablePerson: '考核大類',
    personType: '人員類型',
    KPIfrequency: '默認KPI考核頻率',
    status: '狀態',
    state: '狀態',
    indexModel: '指標模型',
    indexConfig: '指標模型',
    on: '啟用',
    off: '停用',
    frequency: '頻率',
    personTypeConfig: '考核類別設置',
    modelStandard: '模型配置',
    indicatorlibrary: '指標庫',
    compositeIndicator: '組合指標',
    compositeIndex: '組合指標',
    viewDetail: '查看詳情',
    modelName: '模型名稱',
    value: '值',
    targetValue: '目標值',
    evaluationObjectives: '評估目標',
    clone: '複製',
    year: '年度',
    modelConfig: '模型設置',
    type: '類型',
    import: '導入',
    downloadTemp: '下載範本',
    export: '導出',
    maintainTemp: '維護範本',
    importTemp: '導入範本',
    annual: '年度',
    number: '工號',
    name: '姓名',
    department: '部門',
    position: '職位',
    level: '員工級別',
    staffLevel: '員工級別',
    templateType: '範本類型',
    templateName: '範本名稱',
    templateDescription: '範本描述',
    yearBonusTemp: '年終獎範本',
    businessUnits: '業務單位',
    onthespot: '簽約地',
    oper: '操作',
    simplifyDescription: '簡體中文描述',
    traditionalDescription: '繁體中文描述',
    englishDescription: '中文描述',
    targetName: '指標名稱',
    kpiOrNodeWorkObjective: 'KPI或節點工作目標',
    departmentKPI: '部門KPI',
    businessOrWorkPlan: '業務/工作計畫（專案）',
    targetYear: '目標年度',
    historyYear: '複製年度',
    CopyYear: '複製年度',
    unit: '單位',
    challenge: '挑戰',
    budget: '預算',
    lowThanBudget: '低於預算',
    minLimit: '下限',
    indicatorTypes: '指標類型',
    indicatorClassification: '指標分類',
    indexClassification: '指標分類',
    indicatorDescrtion: '指標說明',
    indicatorCode: '指標編碼',
    indexCode: '指標編碼',
    functionalPersonelSubclass: '職能人員子類',
    dataResource: '數據來源',
    dataResource2: '資料來源',
    calculationMethod: '計算方法',
    calculationRule: '計算規則',
    whetherApplyTheDefaultModel: '是否適用預設模型',
    effectDate: '生效時間',
    chooseIndexModel: '選擇指標模型',
    executiveIndicatorModel: '高管指標模型',
    executiveModelName: '高管模型名稱',
    baseIndicator: '基礎指標',
    composeIndicator: '組合指標名稱',
    time: '時間',
    close: '停用',
    returnInfo: '3秒後返回',
    SaleAssessment: '銷售/市場類（考核）',
    SaleComplaint: '銷售/市場類（申訴處理）',
    ExecutiveAssessment: "高管類（考核）",
    assessType: 'KPI/STI',
    assessMethod: '考核方式',
    funcType: '職務類別',
    period: '週期',
    period2: '週期',
    assessmentFrequency: '考核頻率',
    indicatorAttachmentDescr: '指標附件說明',
    attachment: '附件',
    saleRevenuePersonnel: '銷售收入-個人',
    personnelProfit: '利潤-個人',
    tenThousand: '萬元',
    personnelChanges: '異動待處理名單',
    query: '查詢',
    maintain: '維護',
    assessYear: '考核年度',
    assessStartDate: '考核週期開始時間',
    assessEndDate: '考核週期結束時間',
    departmentNumber: '部門編號',
    mainOrPartTime: '主/副崗',
    businessAssessPersonId: '業務線考核人ID',
    businessAssessPersonName: '業務線考核人',
    partTimeAssessIndDesc: '副崗考核',
    weight: '權重',
    weighting: '權重',
    entryDate: '入職日期',
    leaveDate: '離職日期',
    transferDate: '轉崗日期',
    maintenanceRecords: '維護記錄',
    administrativeLine: '行政線',
    businessLine: '業務線',
    haveBusiness: '雙線考核',
    mainAndPostWeight: '主副崗權重',
    subclass: '子類',
    firstAssessor: '一級考核人',
    dottedLineReporterOfAppraisee: '被考核人的虛線彙報人',
    supervisorLineOfDdottedLineReporter: '虛線彙報人的直線上級',
    record: '記錄',
    modifyPerson: '修改人',
    modifyTime: '修改時間',
    queryFailed: '查詢失敗',
    submittedSuccess: '提交成功',
    submittedFail: '提交失敗',
    savedSuccess: '保存成功',
    editSuccess: '編輯成功',
    savedFail: '保存失敗',
    newProcess: '新進處理',
    noNeedProcess: '無需處理',
    salaryType: '薪資類別',
    salaryTypeChangeDate: '薪資類別變化日期',
    sourceDeptName: '原部門',
    sourcePosttionName: '原職位',
    sourceLevel: '原職級',
    targetNameNew: '目標名稱',
    applicableCompany: '適用公司',
    noData: '暫無數據',
    assessmentCategory: '考核類別',
    appraiseCategory: '考核類別',
    fillInActualValue: '填寫實際值',
    actualValueOfSpecialPersonnel: '特殊人員實際值',
    targetManagement: '目標管理',
    compTargetManagement: '公司目標管理',
    scoringManagement: '評估管理',
    setSpecialGoals: '設置特殊目標',
    detail: '詳情',
    copyCategory: '複製類別',
    copyEnterpriseObjectives: '複製企業目標',
    dataPermission: '數據許可',
    targetDescription: '目標描述',
    specialPersonnelObjectives: '特殊審批人目標',
    enterpriseObjectives: '企業目標',
    targetSetting: '目標設置',
    addIndicator: '添加指標',
    selectIndicators: '選擇指標',
    copySelfScheme: '複製本人方案',
    copyOthersScheme: '複製他人方案',
    schemesProportion: '方案占比',
    startDate: '開始日期',
    endDate: '結束日期',
    target: '目標',
    remarks: '備註',
    copyAppraisalScheme: '複製考核方案',
    currentYear: '當前年度',
    copyYear: '複製年度',
    assessmentList: '考核列表',
    setTarget: '設定',
    targetSetting2: '設定',
    targetConfirm: '確認',
    originalAssessmentScheme: '原考核方案',
    proportion: '占比',
    targetModificationDescription: '目標修改說明',
    schemeModificationType: '方案修改類型',
    addScheme: '添加方案',
    targetModification: '目標修改',
    schemes: '方案',
    assessmentCycle: '考核週期',
    indicatorModificationType: '指標修改類型',
    applicationScope: '適用範圍',
    saleAndMarketTargetSetting: '銷售/市場類（目標設置）',
    saleAndMarketTargetModify: '銷售/市場類（目標修改）',
    seniorManagementTarget: '高管類（目標）',
    yes: '是',
    no: '否',
    maintainTarget: '維護目標',
    modifyTarget: '修改目標',
    appraisalQuery: '考核過程&結果',
    resultQuery: '年度綜合結果',
    see: '查看',
    baseInfo: '基礎資訊',
    targetProportion: '目標占比',
    enterValue: '請輸入數值',
    selectCombinationIndicator: '選擇組合指標',
    indicatrix: '指標',
    printPreview: '列印預覽',
    assessmentProcess: '考核流程',
    operator: '操作人',
    operationTime: '操作時間',
    historicalDocuments: '歷史單據',
    treatment: '處理情況',
    handler: '處理人',
    partTimeEndDate: '副崗失效日期',
    weightDistribution: '權重分配',
    weightDistributionConfig: '類型設置',
    notKpiWeight: '非年度KPI權重',
    kpiWeight: '年度KPI權重',
    STIWeight: 'STI權重',
    weightProportion: '權重占比',
    adjustmentRemarks: '調整備註',
    proportionSchemes: '方案占比',
    stiAchievementRate: 'STI達成率',
    kpiAchievementRate: 'KPI達成率',
    stiAchievementRateOfCompany: 'STI達成率-公司',
    stiAchievementRateOfPerson: 'STI達成率-個人',
    adjustment: '調整',
    targetDetails: '目標詳情',
    calculatedAccordingToActualSales: '按照實際銷售計算',
    processPreview: '流程預覽',
    newEmployeesIDP: '新增員工PIP',
    staff: '員工',
    copyInterviewRecords: '複製面談記錄',
    addInterviewRecords: '新增面談記錄',
    copyFromTMC: '從TMC複製',
    affirm: '確認',
    historicalObjectives: '歷史目標',
    actual: '實際',
    achievementRate: '達成率',
    comprehensiveAchievementRate: '綜合達成率',
    unlock: '解鎖',
    applicableDepartment: '適用部門',
    targetType: '目標類型',
    challengeGoal: '挑戰目標',
    basicRequirements: '基本要求',
    addTarget: '添加目標',
    addTo: '添加',
    appraisalCycleSetting: '週期/目標制定人設置',
    isDefaultKPIFrequency: '默認考核週期',
    periodYear: '年',

    newAppraisalCycle: '新增考核週期',
    KPIAssessmentFrequency: 'KPI考核週期',
    STIAssessmentFrequency: 'STI考核週期',
    isSetGoalsForEmployees: '員工制定目標',
    directReports: '直接下屬',
    KPIAnnualScore: 'KPI年度得分',
    abilityScore: '能力得分',
    comprehensiveScore: '綜合得分',
    annualComprehensiveEvaluation: '年度綜合考評',
    confirmResult: '確認結果',
    firstAssessmentLaborNo: '第一考核人工號',
    firstAssessorSpecialist: '第一考核人專員',
    secondAssessmentLaborNo: '第二考核人工號',
    secondAppraiser: '二級考核人',
    HRJobNumber: 'HR工號',
    PersonNumberInChargeOfTheCompany: '公司負責人工號',
    PersonInChargeOfTheCompany: '公司負責人',
    originalPersonnelType: '原人員類型',
    newPersonnelType: '新人員類型',
    reserveBusinessLine: '是否保留解鎖前的業務線',
    reserveConcurrentPost: '是否保留解鎖前的兼崗',
    setGoals: '確定目標',
    departmentalObjectives: '部門目標',
    copyMyTarget: '複製本人目標',
    copyOtherPeopleGoals: '複製他人目標',
    additionalInstructions: '附加說明',
    cycleSetting: '週期設置',
    goalSetting: '目標設定',
    modify: '修正',
    retargeting: '重設',
    completionStatus: '輸入',
    determineResult: '確定結果',
    resultConfirmation: '結果確認',
    IDPCreation: 'PIP創建',
    modificationType: '修改類型',
    modificationReason: '修改原因',
    role: '角色',
    personnel: '人員',
    approvalOpinions: '審批意見',
    viewApprovalComments: '查看審批意見',
    start: '開始',
    complete: '完成',
    executiveType: '高管類型',
    scoreRules: '計分規則',
    modelTargetValue: '銷售STI目標',
    organization: '組織',
    defaultKPIPeriod: '默認週期設置',
    KPIPeriodChangeNode: '您正在修改父級設置，修改父級設置會覆蓋子級的設置，是否繼續',
    unannualKPIWeight: '非年度KPI權重',
    annualKPIWeight: '年度KPI權重',
    weightConfig: '權重設置',
    deleteTips: '至少保留一項數據',
    chooseTips: '至少選擇一項數據',
    chooseOneTips: '只能選擇一項數據',
    alreadyExit: '當前數據已存在',
    dbLineAssConfig: '權重設置',
    // dbLineAssConfig: '雙線考核權重維護',
    time: '時間',
    importFail: '導入失敗',
    importSuccess: '導入成功',
    importExcelTips: '請上傳正確的excel範本',
    autoFillTips: '無需填寫，自動生成',
    executive: '高管',
    weightDistributionCheckTips: "不能為空且不超過100字",
    WeightSetting: "權重設置",
    AssessmentWeight: "考核權重",
    required: "不能為空",
    notMeetRequirements: "要求[0-100]的數",
    CurrentYearDataAlreadyExists: "當前年度數據已存在",// Current year data already exists
    keepAtLeastOne: '至少保留一條',
    administrative_and_business_required_100: '行政線和業務線之和要求為100',
    not_maintained: "未維護",
    draft: "草稿",
    imported: "已導入",
    submitted: "已提交",
    Modification_to_be_submitted: "修改待提交",
    target_confirmed: "目標已確認",
    maintained: "已維護",
    unlocked: "已解鎖",
    aborted: "已中止",
    expired: "已失效",
    instruction_template: "說明範本",
    January: "1月",
    February: "2月",
    March: "3月",
    April: "4月",
    May: "5月",
    June: "6月",
    July: "7月",
    August: "8月",
    September: "9月",
    October: "10月",
    November: "11月",
    December: "12月",
    applicable_personnel: "適用人員",
    manual_calculation: "手工計算",
    newExecutives: '新增高管',
    seniorExecutive: '高管',
    english: '英文',
    chineseAndEnglish: '中英文',
    combinedWeight: '權重合計',
    compositeAchievementRate: '綜合達成率',
    targetNameCheckTips: '請輸入目標名稱',
    targetProportionCheckTips: '請輸入目標占比',
    startDateCheckTips: '請選擇開始日期',
    endDateCheckTips: '請選擇結束日期',
    targetIdCheckTips: '請選擇說明範本',
    appealDetails: '申訴情況',
    appealExplain: '申訴說明',
    additionalPoints: '附加分',
    additionalPointsInstructions: '附加分說明',
    additionalNotes: '附加說明',
    gradingRule: '評分規則',
    score: '評分',
    completeStatus: '完成情況',
    achievementRateAdditionalPoints: '達成率附加分',
    achievementRateAdditionalNotes: '達成率附加分説明',
    indexAttachmentUpload: '指標附件上傳',
    set: '設置',
    appeal: '申訴',
    upload: '上傳',
    appealTips: '請在三個工作日內確認，逾期未確認，視同確認。如有異議請在確認後提交修正申請。',
    appealTips2: '請您確認您的考核目標，如有異議需在10個工作日內提出修正，逾期未提出，視同確認。',
    appealTips3: '請您確認您的考核結果，超出三個工作日視同確認。',
    appealTips4: '請您確認您的考核結果，如有異議需在10個工作日內提出申訴，逾期未提出，視同確認。',
    appealTips5: '請確認您的考核結果，三個工作日內未確認，系統將自動確認。',
    dbAppeal: '二次申訴',
    actualCompleteRate: '實際完成率',
    firstAppealScore: '一次申訴評分',
    secondAppealScore: '二次申訴評分',
    theOriginalKPIScore: '原KPI評分',
    origin: '原',
    end: '結束',
    appealAttachment: '申訴附件',
    investigate: '調查情況',
    suggestedSolutions: '建議解決方案',
    appealType: '申訴處理',
    maintainOriginalState: '維持原結果',
    modifyTheResults: '修改結果',
    dateTips1: '開始日期不能大於結束日期',
    dateTips2: '結束日期不能小於開始日期',
    indexWeight: '指標權重',
    targetCannotBeEmpty: '目標不能為空',
    originalTarget: '原目標',
    newTarget: '新目標',
    logout: '退出登錄',
    downloadSuccessful: '下載成功',
    downloadFailed: '下載失敗',
    selectAtLeastOnePiece: '至少選擇一條數據',
    stiDesc: '按公司實際銷售計算',
    indexUnit: '指標單位',
    tipDesc100: '每個方案中的指標權重之和要等於100',
    copySuccessful: '複製成功',
    copyFail: '複製失敗',
    selectAData: '請選擇一條數據',
    printPreviewFailed: '列印預覽失敗',
    KPIAssessmentFrequencyCheckTips: '請輸入KPI考核頻率',
    setByEmployeeCheckTips: '請選擇是否是員工本人設置目標',
    appraisalCyclePersonCheckTips: '請先選擇考核週期設置人員',
    appraisalFrequencySetCheckTips: '默認考核頻率已設置和未設置的不能進行批量操作',
    setSeparatelyCheckTips: '是10月份後轉崗人員，需要單獨設置',
    yearCheckTips: '年度不能為空',
    departmentCheckTips: '部門不能為空',
    targetNameValueCheckTips: '目標名稱不能為空',
    departmentTargetEmptyTips: '暫未設置部門目標',
    copyYearCheckTips: '請選擇複製年度',
    copyTargetCheckTips: '請選擇複製目標',
    appraisalTargetCheckTips: '請選擇考核目標',
    modelCheckTips: '模型不一致，無法複製',
    copyTargetEmptyTips: '複製的目標指標為空，無法複製',
    result: '結果',
    startTime: '開始時間',
    endTime: '結束時間',
    employeeID: '員工ID',
    departmentID: '部門ID',
    employeeRecords: '員工記錄',
    jobClassification: '職務分類',
    weightOfMainAndAuxiliaryPosts: '主副崗權重',
    transactionDate: '異動日期',
    assessId: '考核ID',
    operationReason: '操作原因',
    salaryTypeChange: '薪資類別變化',
    salaryChangeDate: '薪資異動日期',
    originalEmployeeLevel: '原員工級別',
    originalSalaryCategory: '原薪資類別',
    MainOrAuxiliaryPost: '主/副崗',
    treatmentRecord: '處理記錄',
    approverType: '審批人類型',
    addIndicatorGroup: '添加指標組',
    indicatorGroup: '指標組',
    notFilledIn: '未填寫',
    secondaryConfirm: '確定提交嗎？',
    approveTime: '審批日期',
    secondaryConfirmDelete: '確認刪除嗎？',
    selectedPerson: '已選中人員',
    selectPerson: '選擇人員',
    pleaseComplete: '請填寫完整',
    weightLessThan100: '權重之和要小於100',
    preview: '預覽',
    objectDescOrActionPlan: '目標說明/行動計畫',
    approvalNode: '審批節點',
    approver: '審批人',
    approvalDate: '審批日期',
    oaProcessNo: 'OA流程單號',
    QuickEntry: '快捷入口',
    more: '更多',
    todo: '我的待辦',
    done: '我的已辦',
    personinfo: '個人資訊',
    lv: '級別',
    commonLinks: '常用鏈接',
    myAppraise: '我的績效',
    teamAppraise: '團隊績效',
    return: '返回',
    model: '模型',
    zh: '簡體描述',
    czh: '繁體描述',
    en: '英文描述',
    setSalesSTITarget: '設置銷售STI目標',
    detailed: '明細',
    new: '新增',
    requiredItemsCheckTips: '必填項不能為空（標紅輸入框）',
    linkAddress: '鏈接地址',
    oaApprovalNo: 'OA審批單號',
    scoreManagement: '評分管理',
    AppraisalQuery: '考核查詢',
    AppraisalQuery1: '考核查詢-職能',
    AppraisalQuery2: '考核查詢-銷售/市場',
    AppraisalQuery3: '考核查詢-高管',
    notEqual100: '權重之和不為100',
    empScoreConfirmTips: '請您確認您的考核結果，如有異議需在10個工作日內提出修正，逾期未提出，視同確認。',
    secondAppraiserOnlyOne: '二級考核人只能選一個',
    setValueError: '請設置指標模型',
    errFileType: '檔類型不正確',
    maxFileSizeError: '上傳檔不能大於',
    sameFileError: '不能上傳重名檔！',
    maxFileNameError: '檔長度不能超過80個字元',
    errFileSapce: '檔案名開頭或結尾包含非法字元',
    selectDialog: '選擇',
    weightOfAbilityAssment: '能力考核權重',
    noPermission: '暫無權限',
    modelSortCheckTips: '指標模型值應為升降序（計算方法為按區間時）',
    modelSortCheckTips2: '的指標模型值應為升序或降序（計算方法為 "按區間折算" 或 "按區間壹壹對應" 時）',
    weightCheckTips: '權重不能為空',
    indexNameCheckTips: '指標名稱不能為空',
    indexDescCheckTips: '指標說明不能為空',
    objectDescOrActionPlanTips: '目標說明/行動計劃不能為空',
    dataSourceCheckTips: '數據來源不能為空',
    indicatorModelCheckTips: '指標模型不能為空',
    unitCheckTips: '單位不能為空',
    computeMethodCheckTips: '計算方法不能為空',
    totalWeightCheckTips: '權重總和不為百分之百',
    kpiTotalWeightCheckTips: 'KPI權重總和不為百分之百',
    stiTotalWeightCheckTips: 'STI權重總和不為百分之百',
    rolePermPath: '數據許可訪問路徑',
    putAway: '收起',
    open: '展開',
    richEditorPlaceHolder: '請輸入正文',
    uploadFile: '上傳文件',
    AppraisalYear: '考核年度',
    AppraisalType: '考核類型',
    goalSetter: '目標製定人',
    companyError: '未獲取到該年度的企業指標標準模型，請去配置企業指標標準模型',
    allOption: '請選擇',
    ScoringCriteria: '評分標準',
    level5: '傑出 ——完成挑戰目標',
    level4: '超出預期——雖未能達到挑戰目標，但能超越基本目標要求',
    level3: '合格 ——達到基本目標要求',
    level2: '部分合格 ——結果介於基本要求及下限目標之間，仍需改善',
    level1: '不合格 ——結果低於目標下限',
    levelRemark: '備註：評分可保留小數點之後一位，如3.5，4.1；得分則以四捨五入法保留小數點後兩位',
    objective: '目標',
    percentageOfTarget: '目標占比',
    selectIndicator: '選擇指標',
    selectPortfolioIndicator: '選擇組合指標',
    indicator: '指標',
    description2: '說明',
    pleaseEnter: '請輸入',
    indicatorName: '指標名稱',
    portfolioIndicatorName: '組合指標名稱',
    confirmOk: '確定',
    timeoutErr: '請求無響應或請求超時，請稍後重試',
    permissionErr: '您暫無此功能許可權,部分數據獲取失敗',
    logErr: '您的登陸憑證已經過期，即將重新登陸',
    versionErr: '版本更新中，請稍等',
    assessorType: '被考核人類型',
    annualGroup: '年度組織',
    createUser: '創建人',
    distributionManage: '强制分佈管理',
    approverConfig: '審批人設置',
    DepartHeadSetting: '部門負責人設置',
    duration: '期間',
    primaryArchitecture: '壹級架構',
    secondaryArchitecture: '二級架構',
    tertiaryArchitecture: '三級架構',
    quaternaryArchitecture: '四級架構',
    fifthArchitecture: '五級架構',
    sixthArchitecture: '六級架構',
    seventhArchitecture: '七級架構',
    indexNumber: '指標編號',
    completionRate: '完成率',
    isAnnualIndicator: '是否年度指標',
    salesRevenueCompany: '銷售收入-公司',
    profitCompany: '利潤-公司',
    salesRevenueIndividual: '銷售收入-個人',
    profitIndividual: '利潤-個人',
    indicatorSetting: '指標設置',
    executiveList: '高管名單維護',
    executiveTarget: '高管目標説明配置',
    assessmentInformationMaintenance: '員工信息維護',
    assessmentInformationInquiry: '員工考核查詢',
    salesTargetConfirmation: '銷售目標確認',
    functionalProcess: '職能評分',
    functionalAppeal: '職能申訴',
    functionAddition: '職能附加分',
    functionalTarget: '職能目標',
    saleTargetReport: '銷售市場KPI/STI目標',
    salesKPIScoreReport: '銷售市場KPI評分',
    salesSTIReport: '銷售市場STI匯總表',
    functionalAssessmentReport: '職能績效考核明細表',
    employeeStatus: '員工狀態',
    includedInSTI: '列入STI',
    KPIScore: 'KPI評分',
    colNotFilled: '模型值至少填寫一個',
    functionPermissionCheckTips: '暫無權限使用該功能',
    currentApprover: '當前審批人',
    setBonusCap: '設置人員獎金上限',
    compEval: '綜合考核設置',
    rankingSettings: '排名設置',
    summaryAssessmentReport: '考核結果匯總',
    deptLevel: '層級',
    unlockDate: '解鎖時間',
    operatingUser: '操作用戶',
    history: '歷史記錄',
    appraisalResultTemplate: '考核結果模板',
    bonusCap: '獎金上限',
    automaticallyBroughtOutAndModifiable: '自動帶出可修改',
    LevelID: '等級ID',
    proportion2: '比例',
    sortNumber: '排序號',
    collectionLevel: '歸集等級',
    roundingRule: '取整規則',
    excellent: '優',
    excellentAndGood: '優+良',
    partiallyQualified: '部分合格',
    yearCheckTips2: '請選擇年度',
    deptCheckTips: '請選擇部門',
    annualGroupCheckTips: '請輸入年度組織',
    PersonInChargeOfTheCompanyCheckTips: '請選擇公司負責人',
    addAnnualOrganization: '新增年度組織',
    editAnnualOrganization: '編輯年度組織',
    ruleDescription: '規則描述',
    forcedDistributionRule: '強制分布規則',
    rankingModel: '排名模型',
    ruleDescriptionCheckTips: '請輸入規則描述',
    addForcedDistributionRule: '新增強制分布規則',
    editForcedDistributionRule: '編輯強制分布規則',
    forcedDistributionRuleDetail: '強制分布規則詳情',
    requiredCannotBeBlank: '必填項（*）不能為空',
    rankingModelSortCheckTips: '排名模型排序號不能重復',
    rankingModelProportionCheckTips: '排名模型比例和不為百分之百',
    appraisalOrganization: '考核組織',
    participationInForcedDistribution: '參與強制分布',
    departmentHead: '部門負責人',
    annualOrganizationSettings: '年度組織設置',
    appraiseeSettings: '被考核人員設置',
    psBonusCap: 'PS獎金上限',
    performanceBonusCap: '績效獎金上限',
    performanceBonusCapEdit: '績效獎金上限編輯',
    bonusLimitCheckTips: '請輸入獎金上限',
    automaticCalculation: '自動計算',
    calculationFailed: '計算失敗',
    maintenanceResults: '維護結果',
    reach: '達成',
    total: '合計',
    finalAchievementRate: '最終達成率',
    adjustmentRemarksCheckTips: '請輸入調整備註',
    developmentPlanReport: '個人發展計劃明細表',
    employmentType: '用工類型',
    salesUnlock: '銷售解鎖',
    targetUnlock: '目標解鎖',
    evaluationUnlock: '評估解鎖',
    gradeSimplified: '等級（簡）',
    gradeTraditional: '等級（繁）',
    gradeEnglish: '等級（英）',
    fiveLevelDept: "五級部門",
    deptlead: "是否包含部門負責人",
    category1: "類別",
    staffID: "員工ID",
    computePerson: "計算人",
    computeTime: "計算時間",
    compute: "計算",
    individualSTIAchievementRate: "個人STI達成率",
    companySTIAchievementRate: "公司STI達成率",
    totalSTIAchievementRate: "STI達成率合計",
    salesSTIScoreReport: "銷售市場STI評分",
    firstHalfYear: "上半年度",
    secondHalfYear: "下半年度",
    weightAchievementRate: "權重達成率",
    totalWeightCompany: "權重合計-公司",
    totalWeightIndividual: "權重合計-個人",
    salesResultsSummaryReport: "銷售市場KPI/STI結果匯總表",
    performanceInterview: "績效面談",
    itemsToBeDeveloped: "待發展項",
    interviewRecord: "面談記錄",
    helper: "協助人",
    speedOfProgress: "進度",
    actualCompletionTime: "實際完成時間",
    progressComments: "進度評語",
    cancellationReason: "取消原因",
    actionPlan: "行動計劃",
    plannedCompletionTime: "計劃完成時間",
    actionDescription: "行動描述",
    outputResults: "輸出結果",
    interviewTime: "面談時間",
    functionSalesSTISummaryReport: "職能/銷售市場STI匯總表",
    //汇总得分
    aggregateCalculation: "匯總計算",
    year1: "年度",
    yearOrganization: "年度組織",
    fiveDept: "五級部門",
    deptHeads: "是否包含部門負責人",
    employeeID1: "員工ID",
    compute1: "計算",
    //kpi汇总确认
    specialData: "特殊考核（雙線、主副崗、異動）",
    search1: "查詢",
    confirmScore: "確認得分",
    export1: "導出",
    PersonID: "人員ID",
    department1: "部門",
    KPIScore1: "KPI得分",
    operate: "操作",
    checkDetails: "查看詳情",
    Details: "詳情",
    personType1: "人員類型",
    assessmentMethod: "考核方式",
    jobCategory: "職務分類",
    macPost: "主/副崗",
    assessmentID: "考核ID",
    programme: "方案",
    startingTime: "開始時間",
    endTime1: "結束時間",
    assessmentCycle: "考核週期",
    macPostWeight: "主副崗權重%",
    doubleWeight: "雙線權重%",
    doubleWeight2: "雙線權重",
    TIWeight: "指標權重%",
    TPWeightScheme: "權重方案%",
    KPIScore2: "KPI",
    timeRatio: "時間占比",
    WAScore: "加權平均分數",
    PARate: "方案達成率%",
    GARate: "目標達成率%",
    //sti汇总得分
    TARate: "STI總達成率%",
    ISARate: "個人STI達成率",
    ESARate: "公司STI達成率",
    FARate: "最終達成率",
    WAARate: "加權平均達成率",
    interviewIdp: "面談記錄",
    competencyAppraisalResults: "能力考核結果",
    stiTotalAchievementRate: "STI總達成率",
    annualKPIAchievementRate: "年度KPI達成率",
    annualKPI: "年度KPI",
    abilityAssessment: "能力考核",
    annualComprehensiveScore: "年度綜合得分",
    annualComprehensiveGrade: "年度綜合等級",
    thInterview: "次面談",
    section: "第",
    recorder: "記錄人",
    individualDevelopmentPlan: "發展計劃（可選）",
    toBeDevelopedGoal: "待發展項",
    developmentGoals: "發展目標",
    completionDescription: "完成情況描述",
    uploadAttachments: "上傳附件",
    actionPlanDescription: "計畫內容",
    cancellationReasonCheckTips: "請輸入取消原因",
    actualCompletionTimeCheckTips: "請選擇完成時間",
    hrTodo: "HR待辦",
    employeeInformationToBeMaintained: "員工資訊待維護",
    targetToFollow: "目標待跟進",
    evaluationToBeFollowedUp: "評估待跟進",
    complaintToBeFollowedUp: "申訴待跟進",
    comprehensiveEvaluationToBeReviewed: "綜合考評待審核",
    interviewIDPNotStarted: "面談&PIP未開始",
    myTeam: "我的團隊",
    annualComprehensiveAssessmentScoresAndGrades: "年度綜合考核得分及等級",
    companyTargetExportReport: "公司績效評分報表",
    functionalPerformanceTargetImport: "職能績效目標導入",
    todo2: "待處理",
    submitted2: "已提交",
    KPICompute: "KPI計算",
    STICompute: "STI計算",
    CACompute: "能力考核計算",
    CCCompute: "綜合結果計算",
    notSubmitted: "未提交",
    calculationItems: "計算項目",
    confirmCalculationResults: "確認計算結果",
    annualKPIAchievementRate: "年度KPI達成率",
    annualComprehensiveScore: "年度綜合得分",
    KPIAchievementRate: "KPI達成率%",
    TotalKPIAchievementRate: "總KPI達成率%",
    TotalKPIAchievementRate2: "總KPI達成率",
    assessmentType: "考核類型",
    WAARate: "加權平均達成率",
    capacityCategory: "能力大類",
    score1: "得分",
    weight1: "權重",
    DLAweight: "雙線考核權重",
    PleaseSelectAnnualOrganization: "請選擇年度組織",
    PleaseSelect: "請選擇帶星選項框後再計算",
    PleaseSelect1: "請選擇帶星選項框後再查詢",
    submissionTime: "提交時間",
    actualCheckTips: "指標實際值不能為空",
    functionAppraisalCycleMaintenance: "職能考核周期維護",
    assessTypeCheckTips: "僅能批量提交單壹考核類型目標",
    executivePerformanceSummary: "高管績效匯總表",
    englishName: "英文名字",
    chinahName: "中文名字",
    countryOfContract: "簽約地",
    bonusProportion: "獎金比例",
    targets: "指標",
    stiSpread: "獎金水平",
    totalAchieved: "總達成率",
    specificationOfTarget: "說明",
    achievingRateCompanyCheckTips: "公司達成率為空",
    itemTypeCheckTips: "請選擇待發展項",
    progressCheckTips: "請選擇進度",
    planTypeCheckTips: "請選擇行動計劃",
    planContentCheckTips: "請輸入計劃內容",
    outputResultCheckTips: "請輸入輸出結果",
    evaluationType: '測評類型',
    TMCScore: "TMC得分",
    scoreAfterModification: "修改後得分",
    LastUpdatedBy: "最後更新人",
    updateTime: "更新時間",
    abilityResults: "能力结果",
    rank: "排名",
    Check: "查看",
    performanceLevel: "績效等級",
    originalGrade: "原等級",
    suggestionsFromSuperiors: "上級建議",
    departmentRecommendations: "部門建議",
    forcedDistribution: "強制分布",
    finalGrade: "最終等級",
    reject: "駁回",
    KPIAssessment: "KPI考核(50%)",
    comprehensiveCapacity: "綜合能力(50%)",
    originalGrade1: "原始等級",
    recommendationLevel: "建議等級",
    ratingLevel: "評分等級",
    confirmRanking: "確認排名",
    unlockSuccess: "解鎖成功",
    unlockTips: "解鎖後HR可直接修改結果，無需走申訴審批流程",
    unlockTips2: "解鎖後HR可直接修改目標，無需走目標修改審批流程",
    unlockPartTips1: "確認要解鎖",
    unlockPartTips2: "的評估嗎",
    unlockPartTips3: "的目標嗎",
    synchronizeTMCResults: "同步TMC結果",
    employeeTitle: "員工職別",
    raterID: "評分人ID",
    rater: "評分人",
    scoringTime: "評分時間",
    obtain: "獲取",
    excellent2: '優秀',
    good: '良好',
    qualified: '合格',
    unqualified: '不合格',
    rankingQuery: '排名查詢',
    resultQuery2: '結果查詢',
    interviewIdpInquiry: '面談記錄',
    viewAttachments: '查看附件',
    departmentName: '部門名稱',
    employeesInvolvedInAssessment: '參與考核員工',
    updatedBy: '更新人',
    includingIndividualSTIAchievement: '其中:職能個人STI達成率',
    copyTMCDevelopItem: '復制TMC待發展項',
    summaryStatus: '匯總狀態',
    comprehensiveSummary: '綜合匯總',
    rankingStatus: '排名狀態',
    rating: '評等',
    rankingOfDepartmentHeads: '部門負責人排名',
    rankingOfCompanyPrincipals: '公司負責人排名',
    employeeConfirmation: '員工確認',
    secondaryConfirmReject:'是否確認駁回',
    leadershipScore: '領導力得分',
    leadershipPillar: '領導力支柱',
    leadershipDescription: '領導力描述',
    abilityEvaluation: '能力測評',
    cancelReject:'取消駁回',
    tmcCapabilityAssessmentModification:'TMC能力評估修改',
    tmcScoreEdit:'TMC修改',
    tmcScoreDetail:'TMC詳情',
    summaryScore:'匯總得分',
    summaryCalUnlock:'匯總計算解鎖（IT）',
    rateListDetail:'評等詳情',
    deptRank5:'五級部門排名',
    deptRank5Detail:'五級部門排名-詳情',
    companyChargeRankDetail:'公司負責人排名-詳情',
    actualsuggestions:'實際|建議',
    selectAssessmentMethod:'請選擇考核方式',
    weightSumConfirm:'權重之和必須為100',
    grade:'等級',
    tmcWeightSetInfo:'說明：請維護該員工每一條能力得分的考核方式（行政線/業務線/不計評分），並維護權重。行政線的權重之和需要等於100%，業務線的權重不要單獨維護。',
    change: '變更',
    urge: '催辦',
    completed: '已完成',
    inProgress: '進行中',
    notStarted: '未開始',
    statusStatisticsOfDevItem: '待發展項狀態統計',
    interviewIDPCheckTips: '已完成狀態的面談&PIP不能催辦',
    forcedDistributionLevel: '強制分布等級',
    FARatePercent: "最終達成率%",
    totalAchievedPercent:"總達成率%",
    tmcSyncInfo:'查看同步進度',
    viewImportProgress: '查看導入進度',
    tmcSyncMessage:'同步請求已提交,結果請到"查看同步結果"按鈕查看',
    distributionStandard:'強製分布標準',
    allowDistributionStandard:'符合標準',
    inconformityDistributionStandard:'高於強製分布上限，低於強製分布下限',
    saveConfirm:'頁面存在未保存內容,是否保存',
    noSave:'不保存',
    cancelSave:'取消保存',
    inconformityDistributionStandardTips:'仍有數據不符合強製分布要求,無法提交評分',
    employee:'員工',
    good2:'良',
    refresh:'刷新',
    deptlead2: "包含部門負責人",
    comprehensive:"綜合",
    personSelect:"當前已選擇",
    person:"人",
    search2:'搜索',
    secondConfirmationScorePrompt: '請再次確認是否為最終分數？系統僅提供壹次修改分數的機會，壹旦確認不可再次修改。',
    suggeestionsNumber:'建議數',
    actualNumber:'實際數',
    directReportsDistribution:'直接下屬強製分布',
    deptDistribution:'部門強製分布',
    companyDistribution:'公司強製分布',
    comprehensiveCalculation:"綜合考評結果計算",
    directReportsDistributionDetail:'直接下屬強製分布-詳情',
    deptDistributionDetail:'部門強製分布-詳情',
    companyDistribution:'公司強製分布-詳情',
    forcedDistributionDetail: "強製分布-詳情",
    comprehensiveResults:'綜合結果',
    myPerformanceTodo: '我的績效-待辦',
    myPerformanceQuery: '我的績效-績效查詢',
    viewFunctionAppraisalObjectives: '職能考核目標查看',
    revisionOfFunctionalAssessmentObjectives: '職能考核目標修正',
    functionalAssessmentObjectiveSetting: '職能考核目標設定',
    confirmationOfFunctionalAssessmentObjectives: '職能考核目標確認',
    functionalAssessment: '職能考核評估',
    salesAndMarketAssessment: '銷售/市場考核評估',
    seniorManagementAssessment: '高管考核評估',
    interviewAndIDPMaintenance: '面談&PIP維護',
    interviewAndIDPDetails: '面談&PIP詳情',
    teamPerformanceTodo: '團隊績效-待辦',
    teamPerformanceQuery: '團隊績效-績效查詢',
    departmentObjectiveMaintenance: '部門目標維護',
    departmentObjectiveDetails: '部門目標詳情',
    unlockAppraisalInformation: '考核信息解鎖',
    salesAndMarketAssessmentObjectives: '銷售/市場考核目標',
    executiveAssessmentObjectives: '高管考核目標',
    groupYearConfirmationPrompt: '此年度組織已經更新了納入部門資訊，如果確定編輯，此年度組織已經執行的強制分佈數據會全部清除，請確定是否需要確定編輯？',
    personalPlanEmpty:'個人發展計劃不能為空',
    noInterviewRecord:'無面談記錄',
    IDPnoStart:'待發展項-未開始',
    IDPprogress:'待發展項-進行中',
    stateError:'狀態獲取失敗',
    manuallySelected: '已做人工選擇待發展項，不可再從TMC系統復製',
    correctionNotFilled:'存在未填寫的修正評分',
    helperTips:'請輸入協助人',
    developmentGoalsTips:'請輸入發展目標',
    completionDescriptionTips:'請輸入完成情況描述',
    batchCalculationOfSTI:'批量計算STI達成率',
    STIDetail:'STI詳情',
    DevelopmentPlanStatus:'發展計劃狀態',
    DevelopmentPlanStatusOption:'發展計劃（可選）',
    planNumber: '計劃編號',
    pip: '績效改進計劃',
    planStatus: '計劃狀態',
    trackStatus: '跟蹤狀態',
    planUrge: '計劃催辦',
    trackUrge: '跟蹤催辦',
    submitTime:'提交日期',
    submitTimeTips:'請選擇提交日期',
    PeriodicityNotEstablished:'周期未設定',
    pipNumber: '計劃編號',
    emplId: '工號',
    planFormulationDate: '計畫制定日期',
    withoutPerformanceImprovementPlan: '未做績效改進計畫人員',
    print: '列印',
    selectAll: '全選',
    printSelection: '列印選擇',
    action: '操作',
    indexNum: '序號',
    trackingRecords: '跟蹤記錄',
    pipMethod: '績效表現中存在哪些需要改進地方（盡可能詳細並列舉說明）',
    pipContent: '績效改進期望達到效果是什麼(盡可能列出衡量標準)',
    pipMeasure: '績效改進行動計畫',
    trackingResult: '基於行動計畫的實際績效結果',
    trackingAction: '後續行動',
    uploadSupportFiles: '上傳證明檔',
    quit: '退出',
    performanceTrackingRecords: '績效跟蹤記錄',

    pieceRate: "計件",
    function: "職能",
    sales: "銷售",
    market: "市場",
    newEntry:'新入職',
    resignation:'離職',
    retire:'退休',
    transferjob:'崗位變動',
    endOfPartTimeJob:'兼崗結束',
    otherChanges:'其他變更',
    salaryCategoryConversion:'薪資類別轉換',
    degradation: '降級',
    resignation: '離職',
    retirement: '退休',
    termination: '內退',
    otherChanges: '其他變更',
    hire: '入職',
    transfer: '員工調動',
    rehire: '離職回聘',
    promotion: '晉升',
    addAssistant: '新增副岗',
    invalidAssistant: '失效副岗',
    retireReturn: '退休返聘',
    payChange: '薪資信息更改',
    contractWorker: '合同工',
    laborWorker: '勞務工',
    laborDispatchPersonnel: '勞務派遣人員',
    earlyRetiree: '內退人員',
    intern: '實習生',
    hourlyWorker: '小時工',
    socialWorker: '社工',
    contract: 'Contract',
    temporary: 'Temporary',
    laborDispatchPersonnelB: '勞務派遣人員B',
    recorder: '記錄人',
    printSelection: '列印選擇',
    cancelCalculationResults: "取消確認結果",
    urgeSuccess: '催辦成功',
    urgeFail: '催辦失敗',
    yearFormatError: '年度不能為空',
    No1: '第1次跟蹤記錄',
    No2: '第2次跟蹤記錄',
    No3: '第3次跟蹤記錄',
    No4: '第4次跟蹤記錄',
    No5: '第5次跟蹤記錄',
    No6: '第6次跟蹤記錄',
    No7: '第7次跟蹤記錄',
    No8: '第8次跟蹤記錄',
    No9: '第9次跟蹤記錄',
    No10: '第10次跟蹤記錄',
    loading: '加載中',
    pipTips:'該員工未提交員工信息，請聯繫HR處理。',
    adjustmentValue:'調整值',
}

export default czh